var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedRound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#029435"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.562 7.944c.257-.257.673-.257.93 0L7.029 9.48l3.918-3.918c.257-.257.672-.257.93 0 .257.257.257.673 0 .93l-4.385 4.383c-.128.127-.296.192-.465.192-.169 0-.337-.065-.465-.192L4.56 8.873c-.255-.255-.255-.672.002-.93M8 16c4.41 0 8-3.59 8-8s-3.59-8-8-8-8 3.59-8 8 3.59 8 8 8",
    transform: "translate(-1174 -558) translate(429 550) translate(745 8)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedRound);
export default __webpack_public_path__ + "static/media/checked-round.61bebb3b8216e28f375355f0be9c6c2a.svg";
export { ForwardRef as ReactComponent };